import { ze } from 'utils/zhEn';

export const MinidumpSymbolType = Object.freeze({
  /** 回溯信息：回溯信息用于展开堆栈调用关系，信息来源于可执行文件.so/.dll/.exe中。 */
  UNWIND_INFO: 'UNWIND_INFO',
  /** 还原信息: 还原信息是指令地址与函数信息的映射，信息来源于DWARF文件中的debug段以及PDB文件中。 */
  SYMBOLIC_INFO: 'SYMBOLIC_INFO',
});

const typeToLabel = {
  [MinidumpSymbolType.UNWIND_INFO]: ze('回溯', 'Unwind'),
  [MinidumpSymbolType.SYMBOLIC_INFO]: ze('还原', 'Symbolic'),
};

const typeToDesc = {
  [MinidumpSymbolType.UNWIND_INFO]: ze('回溯信息：回溯信息用于展开堆栈调用关系，信息来源于可执行文件.so/.dll/.exe中。', 'Unwind info: Unwind infomation is used to unwind stack. It is absorbed from executable file with sufix so/dll/exe.'),
  [MinidumpSymbolType.SYMBOLIC_INFO]: ze('还原信息: 还原信息是指令地址与函数信息的映射，信息来源于DWARF文件中的debug段以及PDB文件中。', 'Symbolic info: Symbolic information is the mapping between instruction addresses and function information. It is absorbed from debug section of DWARF files and PDB files.'),
};

export const MinidumpSymbolTypeUtil = Object.freeze({
  makeLabel(type) {
    return typeToLabel[type] || type;
  },

  makeDesc(type) {
    return typeToDesc[type] || type;
  },
});
